<template>
	<PopupRouterViewDetail label="Delegation Setting Detail" @copyDataMethod="copyDataAction">
<!-- APP_DETAIL_HEADER -->
		<b-card>
			<b-col cols="12" lg="6">
					<b-form-group id="fieldset-delegate-from" label-cols-sm="4" label-cols-lg="3" label="Delegate From" label-for="filter-delegate-from">
						{{ model != null ? model.delegateFrom : "" }}
					</b-form-group>
					<b-form-group id="fieldset-delegate-to" label-cols-sm="4" label-cols-lg="3" label="Delegate To" label-for="filter-delegate-to">
						{{ model != null ? model.delegateTo : "" }}
					</b-form-group>
					<b-form-group id="fieldset-period-from" label-cols-sm="4" label-cols-lg="3" label="Period From" label-for="filter-period-from">
						{{ (model != null ? model.periodFrom : "") | moment("DD-MMM-YYYY HH:mm") }}
					</b-form-group>
					<b-form-group id="fieldset-period-to" label-cols-sm="4" label-cols-lg="3" label="Period To" label-for="filter-period-to">
						{{ (model != null ? model.periodTo : "") | moment("DD-MMM-YYYY HH:mm") }}
					</b-form-group>
					<b-form-group id="fieldset-is-all-time" label-cols-sm="4" label-cols-lg="3" label="Is All Time" label-for="filter-is-all-time">
						{{ model != null ? model.isAllTime : "" }}
					</b-form-group>
					<b-form-group id="fieldset-remarks" label-cols-sm="4" label-cols-lg="3" label="Remarks" label-for="filter-remarks">
						{{ model != null ? model.remarks : "" }}
					</b-form-group>
			</b-col>
		</b-card>
<!-- END_APP_DETAIL_HEADER -->
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterViewDetail>
</template>
<script>
/*APP_DETAIL_IMPORT*/
import DelegationSetting from '@/models/DelegationSetting/DelegationSetting';
import DelegationSettingList from '@/models/DelegationSetting/DelegationSettingList';
import DelegationSettingFilter from '@/filters/DelegationSetting/DelegationSettingFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
/*END_APP_DETAIL_IMPORT*/
export default {
	components : {
	/*APP_DETAIL_PROP_DEFINITION*/
	PopupRouterViewDetail,AppInputDatetimepicker,AppInputDatetimepickerRange,
	/*APP_DETAIL_COMPONENTS_DEFINITION*/
},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			model: {},
			/*APP_DETAIL_PAGINATION*/
			/*END_APP_DETAIL_PAGINATION*/
			/*APP_DETAIL_FILTER*/
			filterDelegationSetting : null,
			/*END_APP_DETAIL_FILTER*/
			/*APP_DETAIL_PAGING_DEFINITION*/
			currentDelegationSettingPage : 1,
			delegationSettingPageSize: 10,
			/*END_APP_DETAIL_PAGING_DEFINITION*/
			/*APP_DETAIL_SORT_DEFINITION*/
			sortByDelegationSetting: '',
			sortDescDelegationSetting: '',
			/*END_APP_DETAIL_SORT_DEFINITION*/
			/*APP_DETAIL_VARIABLE_DEFINITION*/
			/*END_APP_DETAIL_VARIABLE_DEFINITION*/
			/*APP_DETAIL_OBJ_VARIABLE*/
			/*END_APP_DETAIL_OBJ_VARIABLE*/
		}
	},
	methods : {
		/*APP_DETAIL_GETDelegationSetting*/
		getDelegationSetting : async function(id) {
			this.isBusy = true;
			DelegationSetting.getData(this, id).then(result => { this.model = result; this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		/*END_APP_DETAIL_GETDelegationSetting*/
		/*APP_DETAIL_COPYDATA*/
		copyDataAction(modelEvent) {
			this.$router.push({ name: 'delegationsettingcopydata', params: { id: this.modelId, copydata : 1 } })
		},
		/*END_APP_DETAIL_COPYDATA*/
		/*APP_DETAIL_DISPLAYFILTER*/
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		/*END_APP_DETAIL_DISPLAYFILTER*/
	},
	/*APP_DETAIL_BEFORE_MOUNT*/
	beforeMount() {
		this.filterDelegationSetting = new DelegationSettingFilter();
	},
	/*END_APP_DETAIL_BEFORE_MOUNT*/
	/*APP_DETAIL_MOUNTED*/
	mounted(){
		let id = this.$route.params.id;
		this.modelId = id;
		this.getDelegationSetting(id);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	/*END_APP_DETAIL_MOUNTED*/
	watch : {
	},
	/*APP_DETAIL_COMPUTED*/
	computed: {
	}
	/*END_APP_DETAIL_COMPUTED*/
}
</script>
